import { useCallback, useEffect, useRef, useState } from 'react';
import api from './api';

let cached = null;

const REFRESH_MARGIN_SECONDS = 60;

const isFresh = (entry) => {
  if (!entry) return false;
  const now = Math.floor(Date.now() / 1000);
  return entry.exp - REFRESH_MARGIN_SECONDS > now;
};

export const fetchEmbedToken = async () => {
  if (isFresh(cached)) return cached;
  const { data } = await api.post('/qassure/embed-token');
  cached = { token: data.token, exp: data.exp, qassureUrl: data.qassure_url };
  return cached;
};

export const clearEmbedToken = () => {
  cached = null;
};

export const useQAssureAuth = () => {
  const [state, setState] = useState({ token: null, qassureUrl: null, error: null, loading: true });
  const mounted = useRef(true);
  const timer = useRef(null);

  const load = useCallback(async () => {
    try {
      const entry = await fetchEmbedToken();
      if (!mounted.current) return;
      setState({ token: entry.token, qassureUrl: entry.qassureUrl, error: null, loading: false });
      const now = Math.floor(Date.now() / 1000);
      const refreshIn = Math.max((entry.exp - REFRESH_MARGIN_SECONDS - now) * 1000, 30_000);
      timer.current = setTimeout(() => {
        clearEmbedToken();
        load();
      }, refreshIn);
    } catch (err) {
      if (!mounted.current) return;
      setState({ token: null, qassureUrl: null, error: err, loading: false });
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    load();
    return () => {
      mounted.current = false;
      if (timer.current) clearTimeout(timer.current);
    };
  }, [load]);

  return { ...state, refresh: load };
};
